import { useVehicleModalStore } from '../state/modalStore.js';
import { SavedVehicle } from '../vehicleHistory.js';
import { RecentVehiclesList } from './RecentehiclesList.js';
import { VehicleSelectionForm, SelectedVehicle } from './VehicleSelectionForm.js';
import CloseIcon from '@mui/icons-material/Close';


export function GlobalVehicleModal() {
  const { isModalOpen, closeModal, fitmentSku, onSelectCallback, ptype } = useVehicleModalStore();

  if (!isModalOpen) {
    return null;
  }

  const handleVehicleSelect = (vehicle: SelectedVehicle) => {
    if (onSelectCallback) {
      onSelectCallback(vehicle);
    }
    closeModal();
  };

  const handleSavedVehicle = (vehicle: SavedVehicle) => {
    if (onSelectCallback) {
      onSelectCallback(vehicle);
    }
    closeModal();
  };

  return (
    <div className="gbrakes-modal-overlay" onClick={closeModal}>
      <div className="gbrakes-modal-dialog" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={closeModal}
          className="gbs-modal-close"
          ><CloseIcon /></button>

        <div className="gbs-modal-content">
          {fitmentSku 
            ? <h3 className="gbs-title gbs-title-fitment">Check Fitment for <span className="gbs-fitment-sku">{fitmentSku}</span></h3>
            : (
              ptype === "clearance" 
              ? <h3 className="gbs-title">Shop Clearance by Ride</h3>
              : <h3 className="gbs-title">Shop by Ride</h3>
            )
          }

          {ptype === "clearance" && (
            <div className="gbclear-block">
              <h4 className="gbclear-title">
                Clearance Sale Products Only
              </h4>
              <div className="gbclear-link">
                <a href="/">Click here for our standard product line</a>
              </div>
            </div>
          )} 

          <div className="gbs-inner-content">
            <VehicleSelectionForm onVehicleSelect={handleVehicleSelect} submitButtonText="Select" ptype={ptype} />

            <div className="gbs-recent-vehicles">
              <h4>Recent Vehicles {fitmentSku && <span>- check fitment</span>}</h4>
              <RecentVehiclesList vehicleAction={handleSavedVehicle} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}